import React from 'react';
import { SearchIcon } from '@heroicons/react/solid';
import MayorView from './MayorView';
import MayorList from './MayorList';

const Sidebar: React.FunctionComponent<any> = ({ type, points, selectedPoint, onClick, onSearch, removePoint, news, showingCGI, setShowingCGI, showingMGI, setShowingMGI, showingLGI, setShowingLGI }) => {
  const [mayorListArray, setMayorListArray] = React.useState<any>(null);
  const searchInput = React.useRef<HTMLInputElement>(null);
  const [searchTerm, setSearchTerm] = React.useState<string | undefined>('');

  React.useEffect(() => {
    setMayorListArray(points);
  }, [points])

  React.useEffect(() => {
    if (selectedPoint) {
      setSearchTerm('');
    }
  }, [selectedPoint]);

  const handleChange = (event?: React.ChangeEvent<HTMLInputElement>) => {
    event?.preventDefault();
    const newValue = event?.target.value || '';
    setSearchTerm(newValue);
    
    // If search input is cleared, reload all cards
    if (newValue === '') {
      onSearch('');
    }
  };

  const onSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    onSearch(searchTerm);
  };

  return (
    <aside className="md:max-w-lg	md:w-3/6 xl:w-2/6 md:h-screen md:pt-6 md:border-r-4 md:border-black">
      <form id="search-container" className="w-full pt-2.5 px-2.5 z-10 bg-white absolute top-0 left-0 md:px-6 h-26 md:static" onClick={onSubmit}>
        <div className="flex items-center border-4 border-black">
          <input value={searchTerm} onChange={handleChange} required ref={searchInput} id="search" name="search" type="text" className="flex-1 font-primary font-bold text-lg px-2.5 py-1 mt-0.5 outline-none leading-none " placeholder="SEARCH" autoComplete="off" />
          <button className="flex-none p-2.5" type="submit">
            <SearchIcon className="h-5 w-5" />
          </button>
        </div>
        {!type &&
          <label htmlFor="search" className="text-sm my-3 block leading-none">Search by location or elected official.</label>
        }
        {type === 'cgi' &&
          <label htmlFor="search" className="text-sm my-3 block leading-none">Search by location or county official.</label>
        }
        {type === 'mgi' &&
          <label htmlFor="search" className="text-sm my-3 block leading-none">Search by location or mayor.</label>
        }
        {type === 'lgi' &&
          <label htmlFor="search" className="text-sm my-3 block leading-none">Search by location or Legislator.</label>
        }
      </form>
      {!selectedPoint &&
        <>
          {mayorListArray?.length > 0 &&
            <MayorList type={type} onClick={onClick} mayors={mayorListArray} />
          }
          {(mayorListArray?.length === 0 && searchInput.current?.value) &&
            <p className="p-6 text-center font-bold text-lg">Unable to find results for "{searchInput.current?.value}".</p>
          }
        </>
      }
      {selectedPoint &&
        <React.Fragment>
          <div className="px-2.5 md:px-6 py-3 md:pt-0">
            <button onClick={() => removePoint()} className="text-sm font-bold leading-none outline-none">
              <span className="text-2xl leading-none mr-1">&#9666;</span> Back to Results
            </button>
          </div>
          <MayorView
            type={type}
            news={news.filter((item: any) => {
              if (selectedPoint?.district) {
                return item?.district?.toLowerCase() === selectedPoint?.district?.toLowerCase() &&
                  item?.state?.toLowerCase() === selectedPoint?.state?.toLowerCase();
              } else if (selectedPoint?.county) {
                return item?.county?.toLowerCase() === selectedPoint?.county?.toLowerCase() &&
                  item?.state?.toLowerCase() === selectedPoint?.state?.toLowerCase();
              } else {
                return item?.city?.toLowerCase() === selectedPoint?.city?.toLowerCase() &&
                  item?.state?.toLowerCase() === selectedPoint?.state?.toLowerCase();
              }
            })
            }
            details={selectedPoint}
          />
        </React.Fragment>
      }
    </aside>
  )
}

export default Sidebar;